export default __webpack_public_path__ + "static/media/fingo-screenshot-01.16709dfa.png";